import { render, staticRenderFns } from "./PageSider.vue?vue&type=template&id=a628e662&"
import script from "./PageSider.vue?vue&type=script&lang=js&"
export * from "./PageSider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports